<template>
  <div>
    <div class="box-header">
      <h3 class="box-title">{{ $t('sidebar.mobileHomeManagement.title') }}</h3>
    </div>
    <div>
      <div class="panel with-nav-tabs panel-primary">
            <div class="panel-heading">
              <ul class="nav nav-tabs">
                <li class="active" @click="onSelectTab(0)">
                  <a href="#tab0primary" data-toggle="tab">{{
                    $t("homeMobileManagement.logo")
                  }}</a>
                </li>
                <li @click="onSelectTab(1)">
                  <a href="#tab1primary" data-toggle="tab">{{
                    $t("homeMobileManagement.information")
                  }}</a>
                </li>
                <li v-if="siteNameInfo !== 2" @click="onSelectTab(2)">
                  <a href="#tab2primary" data-toggle="tab">{{
                    $t("homeMobileManagement.map")
                  }}</a>
                </li>
                <li v-if="siteNameInfo !== 2" @click="onSelectTab(3)">
                  <a href="#tab3primary" data-toggle="tab">{{
                    $t("homeMobileManagement.estimate")
                  }}</a>
                </li>
                <li @click="onSelectTab(4)">
                  <a href="#tab4primary" data-toggle="tab">{{
                    $t("banner.list")
                  }}</a>
                </li>
                <li @click="onSelectTab(5)">
                  <a href="#tab5primary" data-toggle="tab">{{
                    $t("externalLink.title")
                  }}</a>
                </li>
              </ul>
            </div>
            <div class="panel-body">
              <div class="tab-content">
                <div class="tab-pane fade in active" id="tab0primary">
                  <home-mobile-logo ref="mobileLogo"/>
                </div>
                <div class="tab-pane" id="tab1primary">
                  <information-tab ref="informationTab"/>
                </div>
                <div v-if="siteNameInfo !== 2" class="tab-pane fade" id="tab2primary">
                  <!-- <apartment-group ref="apartmentGroup"></apartment-group> -->
                </div>
                <div v-if="siteNameInfo !== 2" class="tab-pane fade" id="tab3primary">
                  <!-- <apartment-group ref="apartmentGroup"></apartment-group> -->
                </div>
                <div class="tab-pane fade" id="tab4primary">
                  <banner-list ref="BannerList"/>
                </div>
                <div class="tab-pane fade" id="tab5primary">
                  <external-link-management ref="ExternalLinkManagement"/>
                </div>
              </div>
            </div>
          </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import HomeMobileLogo from "./HomeMobileLogo.vue"
import InformationTab from "./InformationTab"
import BannerList from '../Banner/BannerList.vue'
import ExternalLinkManagement from "./ExternalLinkManagement"
import config from "../../../build/config"
// import utils from '@/lib/utils'

export default {
  components: {
    HomeMobileLogo,
    InformationTab,
    BannerList,
    ExternalLinkManagement
  },
  data: () => ({
    siteNameInfo: config.SITE_NAME_INFO,
    onTabSelect: 0
  }),
  methods: {
    onSelectTab: function(value) {
      this.onTabSelect = value
      this.$router.replace({
        query: {
          onTabSelect: this.onTabSelect
        }
      })
      this.onShowTabSelect(this.onTabSelect)
    },
    onShowTabSelect: function(tab) {
      $('.nav-tabs a[href="#' + `tab${tab}primary` + '"]').tab('show');
    },
    ...mapActions([])
  },
  mounted() {
    let onTabSelect = this.$route.query.onTabSelect
    if (onTabSelect != undefined) {
      this.onTabSelect = parseInt(onTabSelect)
      this.onShowTabSelect(this.onTabSelect)
    } else {
       this.onShowTabSelect(this.onTabSelect)
    }
  }
}
</script>
<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL PRIMARY ***/
.with-nav-tabs.panel-primary .nav-tabs > li > a,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
}
.with-nav-tabs.panel-primary .nav-tabs > .open > a,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
  background-color: #3071a9;
  border-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.active > a,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:focus {
  color: #428bca;
  background-color: #fff;
  border-color: #428bca;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #428bca;
  border-color: #3071a9;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #fff;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #3071a9;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  background-color: #4a9fe9;
}
</style>


// WEBPACK FOOTER //
// src/views/HomeMobileManagement/HomeMobileManagementAdd.vue